import Axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { APIError, ResidentialZoneWeightItem } from "src/types";

export type RZRestrictionsImportMutationData = {
  weightsFile: File | null;
};

export function useRZRestrictionsImportMutation(zoneId: number | string) {
  async function mutationFn(
    zoneId: number | string,
    data: RZRestrictionsImportMutationData
  ): Promise<AxiosResponse<{ weightList: ResidentialZoneWeightItem[] }, any>> {
    const config = {
      headers: {
        "Content-Disposition": `attachment; filename="${data.weightsFile?.name}"`,
      },
    };

    const response = Axios.put<{ weightList: ResidentialZoneWeightItem[] }>(
      `/planning-api/residentialzones/${zoneId}/weights/import`,
      data.weightsFile,
      config
    );
    return response;
  }
  return useMutation<
    AxiosResponse<{ weightList: ResidentialZoneWeightItem[] }, any>,
    AxiosError<APIError[]>,
    RZRestrictionsImportMutationData,
    unknown
  >((values: RZRestrictionsImportMutationData) => mutationFn(zoneId, values));
}
